(function (window, document) {

  document.addEventListener('DOMContentLoaded', function() {

  Array.from(document.querySelectorAll([
    'iframe[src*="player.vimeo.com"]',
    'iframe[src*="youtube.com"]',
    'iframe[src*="youtube-nocookie.com"]',
    'iframe[src*="kickstarter.com"][src*="video.html"]',
    'object',
    'embed'
  ].join(',')))
    .filter(video => video.closest('object object') === null) // SwfObj conflict patch
    .forEach(video => {
      if (video.tagName.toLowerCase() === 'embed'
        && video.closest('object')
        || video.closest('.video-wrapper')
      ) {
        return;
      }
      const styles = getComputedStyle(video);
      if ((!styles.height && !styles.width) && (isNaN(styles.height) || isNaN(styles.width))) {
          video.setAttribute('height', 9);
          video.setAttribute('width', 16);
      }
      const height = (
          video.tagName.toLowerCase() === 'object'
          || (video.getAttribute('height') && !isNaN(parseInt(video.getAttribute('height'), 10)))
        ) ? parseInt(video.getAttribute('height'), 10) : getComputedStyle(video).height;

      const width = !isNaN(parseInt(video.getAttribute('width'), 10))
        ? parseInt(video.getAttribute('width'), 10)
        : getComputedStyle(video).width;

      const aspectRatio = height / width;

      const wrapper = Object.assign(document.createElement('div'), {
        className: 'video-wrapper',
        style: `padding-top: ${aspectRatio * 100}%;`,
      });
      video.classList.add('video');
      video.removeAttribute('height');
      video.removeAttribute('width');
      const parent = video.parentNode;
      wrapper.appendChild(video);
      parent.appendChild(wrapper);
    });
});

})(window, document);
